import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (v) => { const d = v.replace(/\D/g, '').slice(0, 9); return d.length > 5 ? `${d.slice(0, 3)}-${d.slice(3, 5)}-${d.slice(5)}` : d.length > 3 ? `${d.slice(0, 3)}-${d.slice(3)}` : d; };

// Flag + "Enter full SSN" for profiles created from a last-4-only referral
export const SsnIncompleteFlag = ({ participant, onCompleted, testId = 'ssn-incomplete-flag' }) => {
  const [open, setOpen] = useState(false);
  const [ssn, setSsn] = useState('');
  const [saving, setSaving] = useState(false);
  if (!participant?.ssn_incomplete) return null;
  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/participants/${participant.id}/complete-ssn`, { ssn });
      toast.success('Full SSN saved');
      setOpen(false);
      setSsn('');
      onCompleted();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not save SSN');
    } finally {
      setSaving(false);
    }
  };
  return (
    <span className="inline-flex items-center gap-1">
      <Badge variant="outline" className="bg-amber-50 text-amber-800 border-amber-300" data-testid={testId}>SSN incomplete - last 4 only</Badge>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="link" size="sm" className="h-6 px-1 text-xs" data-testid={`${testId}-enter-btn`}>Enter full SSN</Button>
        </PopoverTrigger>
        <PopoverContent className="w-72 space-y-2">
          <p className="text-sm font-medium">Enter the full SSN</p>
          <p className="text-xs text-muted-foreground">The last 4 must be {participant.ssn_last_four}.</p>
          <Input value={ssn} onChange={(e) => setSsn(fmt(e.target.value))} placeholder="XXX-XX-XXXX" type="password" autoComplete="off" data-testid={`${testId}-input`} />
          <div className="flex justify-end"><Button size="sm" onClick={save} disabled={saving || ssn.replace(/\D/g, '').length !== 9} data-testid={`${testId}-save`}>Save SSN</Button></div>
        </PopoverContent>
      </Popover>
    </span>
  );
};
